module.exports = __webpack_public_path__ + "static/media/klearing_logo.92df3e67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/klearing_logo.svg
// module id = 404
// module chunks = 0